import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import { shutdownFiltersData } from '../../../../../shared/constants';
import { useSearchParams } from '../../../../../shared/lib/searchParams';
import { debounce } from '../../../../../../../helpers/debounce';
import DateRangePickerFooter from '../../../../../../../components/DateRangePickerFooter/DateRangePickerFooter';
import styles from './SelectPeriod.module.scss';

const {
  filters: { period, search },
  changeFilterDelay: delay,
  queryParamDateFormat,
  viewDateFormat,
} = shutdownFiltersData;
const { RangePicker } = DatePicker;

const isDaySame = (start, end) => moment(start).isSame(end, 'day');
const toString = (date) => date.format(queryParamDateFormat);
const toMoment = (dateStr) => moment(dateStr);

const SelectPeriod = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const periodFromParams = searchParams.get(period.name);

  const [value, setValue] = useState(
    (periodFromParams?.split(',') || period.initialValue).map(toMoment)
  );
  const [open, setOpen] = useState(false);

  const handleChange = (dates) => {
    setValue(dates);

    debounce(() => {
      const newParams = new URLSearchParams(searchParams);
      newParams.set(period.name, dates.map(toString));
      newParams.delete(search.name);
      setSearchParams(newParams);
    }, delay)();
  };

  const isFastPeriodActive = (dates) => {
    const [from, to] = dates.range;
    const [fromDate, toDate] =
      periodFromParams?.split(',') || period.initialValue;

    return isDaySame(fromDate, from) && isDaySame(toDate, to);
  };

  useEffect(() => {
    if (periodFromParams && periodFromParams !== value?.map(toString)?.join()) {
      setValue(periodFromParams.split(',').map(toMoment));
    }
  }, [periodFromParams]);

  return (
    <RangePicker
      open={open}
      allowClear={false}
      format={viewDateFormat}
      value={value}
      onChange={handleChange}
      onOpenChange={(status) => setOpen(status)}
      renderExtraFooter={() => (
        <DateRangePickerFooter
          rootClassName={styles.footer}
          isActiveFn={isFastPeriodActive}
          onRangeClick={(dates) => {
            handleChange(dates.range);
            setOpen(false);
          }}
        />
      )}
    />
  );
};

export default SelectPeriod;
